import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import { StyleSheet, css } from 'aphrodite';
import * as FPT from '../utility/fpt'
import AppActions from '../actions/AppActions'
import AppStore from '../stores/AppStore';
import AppDispatcher from '../dispatcher/AppDispatcher'
import TemplateData, { localsMessages } from '../utility/getTemplateData'
import bodymovin from 'bodymovin'
import * as animationData from '../vendor/hearts.json'
import { formatAmount } from '../utility/formator'

const orgname = (TemplateData.donationName) ? TemplateData.donationName : ''
let texts = localsMessages('common/recurring-checkbox')
let textsOr = localsMessages('common/orLine')
let isContinue = false;

const styles = StyleSheet.create({
	wrapper: {},
	centered: {
		display: 'flex',
		justifyContent: 'center'
	},
	toolWrapper: {
		display: 'inline-block',
		marginTop: '20px',
		position: 'relative',
		margin: 'auto',
		paddingBottom: '20px'
	},
	toolCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline',
	},
	toolCheckbox: {
		':before': {
			overflow: 'hidden',
		},
	},
	toolBlurb: {
		fontSize: '15px',
		lineHeight: '20px',
		marginLeft: '40px',
		fontFamily: 'pp-sans-small-regular',
		position: 'relative',
		zIndex: 1,
	},
	toolTip: {
		position: 'fixed',
		zIndex: 1,
	},
	tipIcon: {
		position: 'relative',
		color: '#005EA6',
		cursor: 'pointer',
		textDecoration: 'none',
	},
	helpIcon: {
		textDecoration: 'none',
		color: '#50c7f9',
		fontWeight: 600,
	},
	helpWrapper: {},
	helpTxt: {
		border: '1px solid #50c7f9',
		lineHeight: '1.8',
		textAlign: 'left',
		borderRadius: 6,
		padding: '15px 10px 5px',
		display: 'flex',
		width: '100%',
		maxWidth: 460,
		margin: '0 auto 25px auto',
	},
	helpLeft: {
		width: '30px',
	},
	helpRight: {
		flex: 1,
	},
	helpP: {
		fontSize: 14,
		fontFamily: 'pp-sans-small-regular',
	},
	helpP2: {
		fontSize: 14,
		fontFamily: 'pp-sans-small-regular',
	},
	perMonth: {
		fontSize: 15,
		position: 'relative',
		top: '-5px',
	},
	splitterDiv: {
		height: 55,
	},
	splitterP: {
		fontSize: 15,
		marginBottom: 15,
		display: 'inline',
		marginLeft: 15,
		position: 'absolute',
	},
	animationWrapper: {
		width: '100%',
		position: 'absolute',
		height: 125,
		marginTop: -125,
	},
	animationContainer: {
		height: 250,
		width: 250,
		marginLeft: -35,
	}
})

class Tooltip extends React.Component {
	render() {
		let tooltip1 = texts.rp.tooltipp1;
		let tooltip2 = texts.rp.tooltipp2;
		return (
			<div id="R_toolTip" className={`toolTip ${css(styles.toolTip)}`}>
				<div className="tooltip top hide" id="toolTipBox">
					<div className="recurring-tooltip-arrow"></div>
					<div className="tooltip-inner">
						<p>{tooltip2}</p>
						<p>{tooltip1}</p>
					</div>
				</div>
			</div>
		);
	}
}

class SignupInfo extends React.Component {
	noThanks_closeModal = (event) => {
		AppActions.changeRecurring({ recurring: 'unchecked' });
		AppActions.changeRecurringModalStatus({ recurringModalStatus: 'notclosed' });
		$('#recurringCheckbox').prop('checked', false);
		$('#signupInfo').modal('hide');
	}

	closeModalOnly = (event) => {
		AppActions.changeRecurringModalStatus({ recurringModalStatus: 'closed' });
		$('#signupInfo').modal('hide');
	}

	render() {

		let { label: { or: orLabel } } = textsOr || {};
		let { rp: { signupHeader, dialogp1, dialogp2, dialogp3, continueBtn, noThanksBtn } = {} } = texts || {};

		dialogp1 = dialogp1 && dialogp1.replace('{orgName}', orgname);

		return (
			<div className="modal fade customdialog" data-tabindex="-1" data-role="dialog" id="signupInfo"
				data-backdrop="static">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header text-right">
							<a href="#"
								className="closeBtn icon icon-close-small"
								onClick={this.closeModalOnly}>
							</a>
						</div>
						<div className="modal-body">
							<div className="text-center">
								<img src="https://www.paypalobjects.com/images/Cause/icRecurring.svg" alt="icRecurring" />
							</div>
							<h3 className="text-center">{signupHeader}</h3>
							<div className="modalContent">
								<div className={css(styles.splitterDiv)}>&#9679; <p className={css(styles.splitterP)}>{dialogp1}</p></div>
								<div className={css(styles.splitterDiv)}>&#9679; <p className={css(styles.splitterP)}>{dialogp2}</p></div>
								<div className={css(styles.splitterDiv)}>&#9679; <p className={css(styles.splitterP)}>{dialogp3}</p></div>
							</div>
							<a className="vx_btn vx_btn-primary vx_btn-small r_button" data-dismiss="modal">
								{continueBtn}
							</a>
							<div className="divider">
								<div className="m_content">{orLabel}</div>
							</div>
							<a id="noThanks"
								onClick={this.noThanks_closeModal}
								className="vx_btn vx_btn-primary vx_btn-small r_button borderOnly">
								{noThanksBtn}
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class RecurringCheckBox extends React.Component {
	constructor(props) {
		super(props);
		const amount = AppStore.getDonationAmount() || '';
		const currency = AppStore.getDonationCode() || '';
		this.state = {
			showhelp: this.props.status,
			formatedAmount: formatAmount({ currency: currency, value: amount }),
		};
		this.isToolTipOpen = false;
	}

	componentDidMount() {
		this.dispatcherToken = AppDispatcher.register((payload) => {
			if (payload.action && (payload.action.actionType === 'CHANGE_AMOUNT')) {
				const { action: { item: { amount = 0 } = {} } = {} } = payload;
				this.updateAmount(amount);
			}
		});

		this.addToolTipListeners();
	}

	addToolTipListeners() {
		$('body').on('click', (event) => {
			if (event.target.id === 'tiphelpIcon') {
				return;
			}
		
			if (this.isToolTipOpen) {
				this.handleTipOut(event)
			}
		});

		$(window).on('scroll', (event) => {
			if (this.isToolTipOpen) {
				this.handleTipOut(event);
			}
		});
	 }

	componentWillUnmount = () => {
		isContinue = this.props.continue;
		AppDispatcher.unregister(this.dispatcherToken);
	}

	getToolTipHelpIconPosition() {
		const tiphelpIcon = document.getElementById('tiphelpIcon');
		const tiphelpIconPosition = tiphelpIcon.getBoundingClientRect();
		const { top, left, width } = tiphelpIconPosition;
		
		return {
			top,
			center: left + (width / 2)
		};
	}

	getToolTipDimensions() {
		const toolTipBox = document.getElementById('toolTipBox');
		const toolTipBoxHeight = toolTipBox.clientHeight;
		const toolTipBoxWidth = toolTipBox.clientWidth;
		return {
			toolTipBoxHeight,
			toolTipBoxWidth
		};
	}

	
	loadAnimation(display) {
		if (!display) {
			return;
		}
		$('#animationWrapper').css('display', 'block');
		bodymovin.loadAnimation({
			container: document.getElementById('animationContainer'),
			renderer: 'svg',
			loop: 1,
			autoplay: true,
			// path: 'js/vendor/hearts.json',
			animationData,
		});
		// Destroying with timeout
		setTimeout(() => {
			bodymovin.destroy();
			$('#animationWrapper').css('display', 'none');
		}, 1000);
	}

	updateAmount = (value) => {
		const currency = AppStore.getDonationCode() || '';
		this.setState({ formatedAmount: formatAmount({ currency, value }) });
	}

	handleTipClick = (event) => {
		event.preventDefault();
	}

	handleToolTipIconClick(event) {
		if (this.isToolTipOpen) {
			this.handleTipOut(event);
		} else {
			this.handleTipMove(event);
		}
	}


	/**
	 * onMouseOver callback called on hovering on the recurring tooltip help icon
	 * Shows the tooptip that is centered on the help icon
	 */
	handleTipMove = (event) => {
		const widthOfToolTip = 272;
		const documentWidth = $(document).width();
		const toolTipBox = document.getElementById('toolTipBox');
		$(toolTipBox).removeClass('hide');
		const {
			top,
			center: centerOfTipHelpIcon
		} = this.getToolTipHelpIconPosition();

		const {
			toolTipBoxHeight,
			toolTipBoxWidth
		} = this.getToolTipDimensions();

		// First position the tooltip
		const distanceOfTipHelpIconFromBorder = (documentWidth - centerOfTipHelpIcon);
		const isThereSpaceForToolTip = distanceOfTipHelpIconFromBorder > 136;
		
		// Calculate left position
		let tooltipLeft;
		if (isThereSpaceForToolTip) {
			tooltipLeft = centerOfTipHelpIcon - (toolTipBoxWidth / 2)
			if (tooltipLeft < 0) {
				tooltipLeft = 30;
			}
		} else {
			// 30px from the document's right end
			tooltipLeft = documentWidth - widthOfToolTip - 30;
		}

		// Position the tooltip	
		$('.toolTip').css({
			'top': top - toolTipBoxHeight,
			'left': tooltipLeft // align the center of tooltip box with the center of toolTipHelpIcon
		});
		// Position the arrow
		const arrowLeft = centerOfTipHelpIcon - tooltipLeft;
		$('.recurring-tooltip-arrow').css({
			left: arrowLeft
		});

		this.isToolTipOpen = true;
	}

	handleTipOut = (event) => {
		let toolTipBox = document.getElementById('toolTipBox');
		$(toolTipBox).addClass('hide');
		this.isToolTipOpen = false;
	}

	handleChange = (ev) => {
		let { showhelp } = this.state;
		let isChecked = ev.target.checked;
		let chkBxStatus = isChecked ? 'checked' : 'unchecked';

		this.loadAnimation(isChecked);

		AppActions.changeRecurring({
			recurring: chkBxStatus
		});
		FPT.trackLinkClickWithData('recurringChkBx', {
			checkbox: chkBxStatus
		});

		this.props.handleChange(isChecked);

		this.setState({ showhelp: showhelp = !showhelp });
	}

	createMarkup = (content) => {
		return { __html: content };
	}

	render () {
		let { recurring_label, perMonth, helpText1, helpText2 } = texts.rp;

		helpText1 = helpText1 && helpText1.replace('{orgName}', orgname);
		helpText1 = helpText1 && helpText1.replace('{amount}', this.state.formatedAmount);

		return (
			<div className={`row ${css(styles.wrapper)}`}>
				<div className="col-xs-12 col-sm-12 col-md-12">
					{isContinue ?
						<div className={css(styles.centered)}>
							<div className={css(styles.toolWrapper)}>
								<p className={`text-center ${css(styles.perMonth)}`}>
									{perMonth}
								</p>
							</div>
						</div> :
						<div className={css(styles.centered)}>
							<div className={css(styles.toolWrapper)}>
								<div className={css(styles.animationWrapper)} id="animationWrapper" style={{ display: 'none' }}>
									<div className={css(styles.animationContainer)} id="animationContainer"></div>
								</div>
								<div className={`vx_checkbox ${css(styles.toolCheckboxWrapper)}`}>
									<input type="checkbox"
										checked={this.props.status}
										name="recurringCheckbox"
										id="recurringCheckbox"
										onChange={this.handleChange} />
									<label htmlFor="recurringCheckbox" className={css(styles.toolCheckbox)}>
										<span className="sr-only">{recurring_label}</span>
									</label>
								</div>
								<p className={css(styles.toolBlurb)}>{recurring_label}
									<a href="#"
										onClick={(event) => this.handleToolTipIconClick(event)}
										className={`icon icon-small icon-tooltip-outline-small ${css(styles.tipIcon)}`}
										aria-hidden="true"
										id="tiphelpIcon">
									</a>
								</p>
								<Tooltip/>
							</div>
						</div>
					}
				</div>
				{this.state.showhelp && <div className={`col-xs-12 col-sm-12 col-md-12 ${css(styles.helpWrapper)}`}>
					<div className={`${css(styles.helpTxt)}`}>
						<div className={`${css(styles.helpLeft)}`}>
							<a className={`icon icon-small icon-info-large ${css(styles.helpIcon)}`}
								aria-hidden="true">
							</a>
						</div>
						<div className={`${css(styles.helpRight)}`}>
							<p className={css(styles.helpP)} dangerouslySetInnerHTML={this.createMarkup(helpText1)}></p>
							<p className={css(styles.helpP2)} dangerouslySetInnerHTML={this.createMarkup(helpText2)}></p>
						</div>
					</div>
				</div>}
				<SignupInfo/>
			</div>
		);
	}
}

RecurringCheckBox.propTypes = {
	handleChange: PropTypes.func,
	showNote: PropTypes.bool,
	hasRecurringHelp: PropTypes.bool,
	status: PropTypes.bool,
	continue: PropTypes.bool,
};

RecurringCheckBox.defaultProps = {
	handleChange: () => {},
};

export default RecurringCheckBox



// WEBPACK FOOTER //
// ./components/recurring-checkbox.js